import React from "react";
import dClient from './../../Components/api/reduxLoaderApi';

import failStatus from "../../Components/utils/failStatus";
import {notification} from "../../Components/functions/notification/notificationFunction";



export const sendMessage = (data, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient(
        'post',
        `admin/send/sms/group`,
        data,
        {},
        1,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    return callback && callback(res);
};
